import { fuzzySearch } from "levenshtein-search";
import * as _ from "lodash";

/**
 * Filter an object by the Levenshtein distance of its values from a given term
 * @param {R} source
 * @param {string} term
 * @param {number} distance
 * @param {(item: R[keyof R]) => string} valueGetter
 * @return {R}
 */
export const filterByDistance = <R extends Record<string, unknown> = Record<string, unknown>>(
  source: R,
  term: string,
  distance = 3,
  valueGetter: (item: R[keyof R]) => string = (i) => {
    if (_.isString(i)) {
      return i;
    }

    throw new Error("You need to specify a value getter.");
  }
): R => _.pickBy<R>(source, (v) => [...fuzzySearch(term, valueGetter(v), distance)].length > 0) as R;
